import script from "./sign.vue?vue&type=script&setup=true&lang=js"
export * from "./sign.vue?vue&type=script&setup=true&lang=js"

import "./sign.vue?vue&type=style&index=0&id=a7d116ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7d116ca"]])

export default __exports__